import { Component, ChangeDetectionStrategy } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-password',
    templateUrl: './password.component.html',
    styleUrls: ['./password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PasswordComponent extends InputComponent {

    public hide: boolean = true;
}
